import React from 'react';
import { useDispatch } from 'react-redux';

import { status } from '../Actions/Overlay.action';

export default function NavigationOverlay() {
    const dispatch = useDispatch();
    const onClick = () => {
        dispatch(status(false));
    };
    return <div className="overlay" onClick={onClick}></div>;
}
